export const SVC_URLS = {
  ecom: process.env.REACT_APP_ECOM_BASE_URL,
  ops: process.env.REACT_APP_OPS_BASE_URL,
  auth: process.env.REACT_APP_AUTH_BASE_URL,
};
